import { Box, Typography } from "@mui/material";
import useColors from "../../../api/hooks/useColors";
import {
  getCoverageColor,
  getCoverageLabel,
  getRiskColor,
  getRiskLabel,
  SEVERITY,
} from "./utils";

const HeatmapLegend = ({ showRisk }) => {
  const colors = useColors();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        gap: 2,
        alignItems: "center",
      }}
    >
      {Object.values(SEVERITY).map((severity) => (
        <Box
          key={severity}
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: 1,
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              minWidth: "12px",
              minHeight: "12px",
              maxWidth: "12px",
              maxHeight: "12px",
              boxShadow:
                "0px 0px 1px 0.5px " + colors.grey_24percent + " inset",
              backgroundColor: showRisk
                ? getRiskColor(severity, colors)
                : getCoverageColor(severity, colors),
              borderRadius: 1,
            }}
          ></Box>
          <Typography
            variant="caption"
            sx={{
              color: colors.text_secondary,
            }}
          >
            {showRisk ? getRiskLabel(severity) : getCoverageLabel(severity)}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default HeatmapLegend;
